import { render, staticRenderFns } from "./PermissionSetting.vue?vue&type=template&id=0991930a"
import script from "./PermissionSetting.vue?vue&type=script&lang=js"
export * from "./PermissionSetting.vue?vue&type=script&lang=js"
import style0 from "./PermissionSetting.vue?vue&type=style&index=0&id=0991930a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports